import { Reducer } from 'redux';
import { call, put, take } from 'redux-saga/effects';
import { FETCH_USER_CHANNEL, UPDATE_USER_CHANNEL } from './action-types';
import { fetchJson, getChannelResourceCode } from 'src/utils';

export type UserChannelState = {
  channelName?: string;
  channelRight?: number;
  channelSource?: string;
  channelPaymentWay?: string;
  isHide?: 'Y' | 'N'
  [k: string]: any;
};

export const userChannel: Reducer<UserChannelState> = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_USER_CHANNEL:
      return { ...state, ...action.channel };
    default:
      return state;
  }
};

export function* fetchUserChannel() {
  const { code, result } = yield call(fetchJson, {
    type: 'GET',
    url: '/api/api/v1/patient/channel/getUserChannel',
    data: {
      channelResourceCode: getChannelResourceCode(),
    },
    needLogin: false,
    isloading: false,
  });

  if (code === '0') {
    yield put({ type: UPDATE_USER_CHANNEL, channel: result || {} });
  }
}

export function* channel() {
  while (true) {
    yield take(FETCH_USER_CHANNEL);
    yield call(fetchUserChannel);
  }
}
